import { LitElement, html, css } from 'lit';

class ModalElement extends LitElement {
  static get properties() {
    return {
      isOneButton: { type: Boolean },
      submitDisabled: { type: Boolean },
      show: { type: Boolean },
      isBuyModal: { type: Boolean },
      hideButtons: { type: Boolean },
      leftButtonText: { type: String },
      rightButtonText: { type: String }
    };
  }

  constructor() {
    super();
    this.isOneButton = false;
    this.submitDisabled = false;
    this.show = false;
    this.isBuyModal = false;
    this.hideButtons = false;
    this.leftButtonText = 'Nevermind';
    this.rightButtonText = 'Submit';
  }

  handleCloseClick() {
    this.dispatchEvent(new Event('close'));
  }

  handleSubmitClick() {
    this.dispatchEvent(new Event('submit'));
    this.dispatchEvent(new Event('close'));
  }

  handleAddAnotherClick() {
    if (!this.submitDisabled) {
      this.dispatchEvent(new CustomEvent('submit'));
    }
  }

  static get styles() {
    return css`
      :host {
        display: block;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 999;
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.3s ease;
        --text-alignment: center;
        --modal-max-width: 352px;
        --left-button-text-color: #FFFFFF;
        --left-button-background-color: #F84439;
        --left-button-hover-color: #660000;
        --right-button-text-color: #FFFFFF;
        --right-button-background-color: #3346E7;
        --right-button-hover-color: #003580;
      }

      :host([show]) {
        opacity: 1;
        pointer-events: auto;
      }

      button {
        font-family: Outfit;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        border: none;
        cursor: pointer;
      }

      .modal {
        position: absolute;
        min-width: 350px;
        max-width: var(--modal-max-width);
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background-color: white;
        padding: 24px;
        border-radius: 5px;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
        overflow-y: auto;
        display: flex;
        justify-content: center;
        align-items: var(--text-alignment);
        flex-direction: column;

        @media (max-width: 479px) {
          min-width: 300px;
        }
      }

      .close-button {
        position: absolute;
        top: 10px;
        right: 10px;
        background: none;
        border: none;
        font-size: 16px;
        font-weight: bold;
        color: #000;
        cursor: pointer;
      }

      .button-container {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        width: 100%;
      }

      .get-started-container {
        display: flex;
        width: 350px;
        justify-content: center;

        @media (max-width: 479px) {
          width: 300px;
        }
      }

      .left-button {
        display: flex;
        min-width: 85px;
        padding: 8px 12px;
        justify-content: center;
        align-items: center;
        gap: 8px;
        background: var(--left-button-background-color);
        color: var(--left-button-text-color);
      }

      .left-button:hover {
        background-color: var(--left-button-hover-color);
      }

      .right-button {
        display: flex;
        min-width: 85px;
        padding: 8px 22px;
        justify-content: center;
        align-items: center;
        gap: 8px;
        background: var(--right-button-background-color);
        color: var(--right-button-text-color);
      }

      .right-button:hover {
        background-color: var(--right-button-hover-color);
      }

      .right-button:disabled {
        background-color: #3346E7;
        cursor: not-allowed;
        opacity: 0.5;
      }

      .footer-container {
        margin-top: 20px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .required-tag {
        font-size: 12px;
        color: #2E2E3A;
        font-family: 'Montserrat', sans-serif;
        display: inline-flex;
        align-items: center;
      }

      .required-asterisk {
        color: #DC3545;
        margin-right: 2px;
        font-size: 20px;
        margin-left: 0;
        line-height: 1;
        vertical-align: middle;
      }

      .add-another {
        color: #3346E7;
        font-size: 12px;
        cursor: pointer;
        text-decoration: underline;
      }
    `;
  }

  render() {
    return html`
      <div class="modal">
        <button class="close-button" @click="${this.handleCloseClick}">✕</button>
        <slot name="modal-slot"></slot>
        ${!this.hideButtons
          ? html`
              ${this.isOneButton
                ? html`
                    <div class="get-started-container">
                      <button class="submit" @click="${this.handleCloseClick}">Get Started</button>
                    </div>`
                : html`
                    <div class="button-container">
                      <button class="left-button" @click="${this.handleCloseClick}">${this.leftButtonText}</button>
                      <button class="right-button" @click="${this.handleSubmitClick}" .disabled="${this.submitDisabled}">${this.rightButtonText}</button>
                    </div>
                    ${this.isBuyModal
                      ? html`
                          <div class="footer-container">
                            <div class="required-tag">
                              <span class="required-asterisk">*</span> Required
                            </div>
                            <div class="add-another" @click="${this.handleAddAnotherClick}">
                              Submit and add another trade
                            </div>
                          </div>`
                      : ''
                    }
                  `
              }
            `
          : ''
        }
      </div>
    `;
  }
}

customElements.define('modal-element', ModalElement);
